import { LoaderFunctionArgs, redirect } from "react-router";

export default async function contractsLoader(args: LoaderFunctionArgs) {
  const routeParams = args.params;
  if (!routeParams) return redirect("/contracts/conflicts");
  return routeParams;
}
